import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { vehicleOwner } from "../_types/vehicleOwner";

@Injectable({
    providedIn: 'root',
})

export class VehiclesOwnersService extends Service<vehicleOwner> {
  public override type = 'vehicleOwners';
  public override url = 'providers/vehicleOwners'; 
    
}
